export interface FAQItem {
  question: string;
  answer: string;
}

export const faqData: FAQItem[] = [
  {
    question: "What is the best time to visit Kashmir?",
    answer:
      "The best time to visit Kashmir is from March to August when the weather is pleasant and the natural beauty is at its peak.",
  },
  {
    question: "What are the top attractions in Kashmir?",
    answer:
      "Top attractions include Srinagar’s Dal Lake, Gulmarg, Pahalgam, and the beautiful gardens of Shalimar Bagh and Nishat Bagh.",
  },
  {
    question: "Is it safe to travel to Kashmir?",
    answer:
      "Travel safety can vary. It’s best to check current travel advisories and consult local guides to ensure a safe trip.",
  },
];
